export default "<p>blog-section-two works!</p>\n";